var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-arrowbox",style:(_vm.getWrapperStyle)},[_c('div',{staticClass:"arrow"}),_vm._v(" "),_c('div',{staticClass:"content",style:(_vm.getContentStyle)},[(_vm.title)?_c('div',{staticClass:"title"},[_c('h4',[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }